import React, { useState, useEffect, useContext } from 'react';
import { CSVLink } from 'react-csv';
import { Grid, Button, Tooltip } from "@material-ui/core";
import { saveAs } from 'file-saver';
import JSZip from "jszip";
import Cookies from "universal-cookie";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-regular-svg-icons";

import { AuthContext } from "../../../../../../../../../../contexts/AuthContext";
import SearchField from '../../../../../../../../../util/searchPedido/.mixins';
import OpcoesBuscaPopoverAllFilter from '../../../../../../../../../util/opcoesBuscaPopoverAllFilters/.mixins';
import FiltroStatusPedido from '../../../../../../../../../util/filtroStatusPedido/.mixins';
import TableColView from '../../../../../../../../../util/mostrarColunas/.mixins/mostrarColunas';
import MultiSelectModal from '../../../../../../../../../util/modalDinamica/childrens/modalRadioButton/.mixins/multiSelectModal';
import ModalManualEtiqueta from '../../../../../../../../../util/manualEtiquetas/.mixins';
import Tabela from '../childrens/tabela/.mixins';
import ModalTodosPedidosNovaOpcao from '../childrens/modalTodosPedidosNovaOpcao/.mixins';
import { useTooltipEtiqueta } from '../childrens/downloadEtiquetas/hooks/useTooltipEtiqueta';
import { DownloadOpcoes } from '../childrens/downloadEtiquetas/downloadOpcoes';
import { DownloadConcluido } from '../childrens/downloadEtiquetas/downloadConcluido';
import { GerenciarPedidoContext } from '../../../../../../../../../../contexts/gerenciarPedidos';
import { useModal } from '../../../../../../../../hooks/useModal';
import Etiqueta_controller from '../../../../../../../../../../controllers/etiqueta';

//css
import StylesCss from './styles';
const useStyles = StylesCss();

export default (props) => {
  const {
    state: {
      searchFieldTodosPedidos,
      searchFieldExternalTodosPedidos,
      dtInitialTodosPedidos,
      dtEndTodosPedidos,
      escolhaDataTodosPedidos,
      escolhaFilialTodosPedidos,
      escolhaCondicaoTodosPedidos,
      colunasTodosPedidos,
      colunasFilterTagsTodosPedidos,
      opcoesFilial,
      opcoesCondicao,
      opcoesFiltroPedidos,
      isLoading,
      dataTodosPedidos,
      dataTodosPedidosIndexSelected,
      gruposColunasTodosPedidos,
      columnsTodosPedidos,
      openModalNovaOpcaoTodosPedidos,
      escolhaModalItensNovaOpcaoTodosPedidos,
      opcoesModalItensNovaOpcao,
      openModalItensNovaOpcaoTodosPedidos,
      qtdTodosPedidos,
      pageInitialTodosPedidos,
      pageRowsTodosPedidos,
      rowsPerPageOptionsTodosPedidos,
      dataTodosPedidosSelectedEtiquetas,
    },
    handleChangeSearchFieldPedidoTodosPedidos,
    handleChangeSearchFieldExternalPedidoTodosPedidos,
    handlerChangeDateInitialTodosPedidos,
    handlerChangeDateEndTodosPedidos,
    handlerChangeRadioEscolhaDataTodosPedidos,
    handlerChangeEscolhaFilialTodosPedidos,
    handlerChangeEscolhaCondicaoTodosPedidos,
    handlerChangePageTodosPedidos,

    handleClickSearchFieldTodosPedidos,

    handlerFiltroPedidos,
    handlerDataTodosPedidosSelected,
    handlerClearFilterTagTodosPedidos,
    handlerClickCheckboxTodosPedidos,

    handlerCleanFiltersTodosPedidos,
    handlerAplicarFiltersTodosPedidos,

    onColumnUpdateTodosPedidos,

    handlerModalNovaOpcaoCloseTodosPedidos,
    handlerModalNovaOpcaoEntendidoTodosPedidos,

    handlerModalItensNovaOpcaoAplicarAlteracoesTodosPedidos,
    handlerModalItensNovaOpcaoCloseTodosPedidos,
    handlerModalItensNovaOpcaoChangeTodosPedidos,

    handlerChangeRowsPerPageTodosPedidos,
    setState,
    getNomeProdutosSelectedEtiquetas,
    shapeEtiquetasObject,
    getFilters,
  } = props;
  const router = props.props.router
  const classes = useStyles();
  let gerenciarPedidoContext = useContext(GerenciarPedidoContext);
  const { user: { isVisaoTok } } = useContext(AuthContext);
  const exportData = JSON.parse(JSON.stringify(dataTodosPedidos)).map((item) => {
    delete item.OPCOES_RECEBIMENTO;
    return item;
  });

  const { tooltip, isDownloadButtonDisabled } = useTooltipEtiqueta(dataTodosPedidosSelectedEtiquetas.length);
  const [produtosSelectedEtiquetas, SetProdutosSelectedEtiquetas] = useState([]);
  const [modalManual, setModalManual] = useState(false);
  const [controlUpdate, setControlUpdate] = useState(false);

  const { Modal: ModalEtiquetaOpcoes, toggleModal: toggleModalEtiquetaOpcoes } = useModal();
  const { Modal: ModalEtiquetaConcluido, toggleModal: toggleModalEtiquetaConcluido } = useModal();

  const handleClickDownloadEtiquetas = async (tipo) => {
    const cookies = new Cookies();
    const token = cookies.get('User-Token');

    const body = shapeEtiquetasObject();

    setState({
      progressPercentZipBoolean: true,
    });

    let j_o_postUrls = [];
    // chunk parametro de quantidade de requisicoes /urls
    let i, j, temporary, chunk = 1;
    for (i = 0, j = body.length; i < j; i += chunk) {
      temporary = body.slice(i, i + chunk);
      const o_postUrls = await Etiqueta_controller.postUrls(tipo, temporary, token);
      const jr = await o_postUrls.json();
      j_o_postUrls = j_o_postUrls.concat(jr);
    }

    if (j_o_postUrls == null) {
      return;
    }

    const zip = new JSZip();

    const bar = new Promise((resolve, reject) => {
      j_o_postUrls.forEach(async (keyname, i, array) => {
        const query = { key: keyname, UserToken: token };
        const o_qualidade = await Etiqueta_controller.getDownload(query);
        const o_qualidade_blob = await o_qualidade.blob();
        const name = keyname.split("/")[3];
        zip.file(name, o_qualidade_blob);
        if (Object.keys(zip.files).length === array.length) {
          resolve();
        }
      });
    });

    bar.then(() => {
      // timeout necessário para esperar a escrita do arquivo pra dentro do zip
      setTimeout(() => {
        zip.generateAsync({
          type: "blob",
          compression: "DEFLATE",
          streamFiles: true,
          compressionOptions: { level: 6 }
        },
          updateCallback
        ).then(async (content) => {
          saveAs(content, `Etiquetas expedição T&S_${new Date().getTime()}.zip`);
        });
      }, 1000);
    });
  };

  const updateCallback = (metaData) => {
    const percent = metaData.percent;
    // timeout necessário para atualização do metadata
    setTimeout(() => {
      setState({
        progressPercentZip: percent.toFixed(2),
        progressPercentZipBoolean: true
      });

      if (percent === 100) {
        setTimeout(() => {
          setState({
            progressPercentZip: 0,
            progressPercentZipBoolean: false,
          });
          toggleModalEtiquetaConcluido();
        }, 1000);
      }
    }, 10);
  };

  const handleClickModalDownloadEtiquetas = async (tipo) => {
    toggleModalEtiquetaOpcoes();
    try {
      await handleClickDownloadEtiquetas(tipo);
    } catch (error) {
      console.error(error);
    }
  };

  const handleClickDownloadEtiquetasButton = () => {
    const produtos = getNomeProdutosSelectedEtiquetas();
    SetProdutosSelectedEtiquetas(produtos);
    toggleModalEtiquetaOpcoes();
  };

  const loadData = async () => {
    if (gerenciarPedidoContext.flagEventClickHistoricoPedido === true) {
      gerenciarPedidoContext.flagEventClickHistoricoPedido = false;
      setControlUpdate(true);
      const params = gerenciarPedidoContext.filters;
      if (isVisaoTok) {
        const position = params.colunasFilterTagsTodosPedidos.findIndex(x => x.key === "Fornecedor")
        const concatValue = `${params.fornecedor} - ${params.fornecedorName}`
        if (position === -1) {
          params.colunasFilterTagsTodosPedidos.push({
            key: "Fornecedor",
            value: concatValue,
            origemValue: ""
          })
        } else {
          params.colunasFilterTagsTodosPedidos[position].value = concatValue
        }
      }

      await props.setState({
        isLoading: true,
        pageInitialTodosPedidos: params.pageInitialTodosPedidos,
        searchFieldExternalTodosPedidos: params.searchFieldExternalTodosPedidos,
        fornecedor: params.fornecedor,
        fornecedorName: params.fornecedorName,
        colunasFilterTagsTodosPedidos: params.colunasFilterTagsTodosPedidos,
        dtInitialTodosPedidos: params.dtInitialTodosPedidos,
        dtEndTodosPedidos: params.dtEndTodosPedidos,
        escolhaDataTodosPedidos: params.escolhaDataTodosPedidos,
        escolhaFilialTodosPedidos: params.escolhaFilialTodosPedidos,
        escolhaCondicaoTodosPedidos: params.escolhaCondicaoTodosPedidos,
        opcoesFiltroPedidosValue: params.opcoesFiltroPedidosValue,
        dataTodosPedidosSelected: params.dataTodosPedidosSelected,
        dataTodosPedidosIndexSelected: params.dataTodosPedidosIndexSelected,
        dataTodosPedidosSelectedEtiquetas: params.dataTodosPedidosSelectedEtiquetas,
        pageRowsTodosPedidos: params.pageRowsTodosPedidos,
      });

      await props.loadTodosPedidos({
        linha_inicial: 0,
        qtd_registro: 5,
        tipo_load:
          params.searchFieldExternalTodosPedidos !== "" ? "searchField" : "applyFilters",
      });
    } else {
      if (isVisaoTok) {
        const position = getFilters().colunasFilterTagsTodosPedidos.findIndex(x => x.key === "Fornecedor")
        if (position !== -1) {
          handlerClearFilterTagTodosPedidos(position)
        }
      }

      await props.setState({
        isLoading: true,
        firstLoad: true,
      });
      await props.loadTodosPedidos({
        linha_inicial: 0,
        qtd_registro: 5,
        tipo_load: "changeTab",
      });
    }
    await props.setState({ isLoading: false, firstLoad: false });
  };

  const saveFilter = () => {
    const state = getFilters();
    gerenciarPedidoContext.flagEventClickHistoricoPedido = true;
    gerenciarPedidoContext.filters = {
      pageInitialTodosPedidos: state.pageInitialTodosPedidos,
      fornecedor: state.fornecedor,
      fornecedorName: state.fornecedorName,
      searchFieldExternalTodosPedidos: state.searchFieldExternalTodosPedidos,
      colunasFilterTagsTodosPedidos: state.colunasFilterTagsTodosPedidos,
      dtInitialTodosPedidos: state.dtInitialTodosPedidos,
      dtEndTodosPedidos: state.dtEndTodosPedidos,
      escolhaDataTodosPedidos: state.escolhaDataTodosPedidos,
      escolhaDataTodosPedidos: state.escolhaDataTodosPedidos,
      escolhaFilialTodosPedidos: state.escolhaFilialTodosPedidos,
      escolhaCondicaoTodosPedidos: state.escolhaCondicaoTodosPedidos,
      opcoesFiltroPedidosValue: state.opcoesFiltroPedidosValue,
      dataTodosPedidosSelected: state.dataTodosPedidosSelected,
      dataTodosPedidosIndexSelected: state.dataTodosPedidosIndexSelected,
      dataTodosPedidosSelectedEtiquetas: state.dataTodosPedidosSelectedEtiquetas,
      pageRowsTodosPedidos: state.pageRowsTodosPedidos,
    }
  }

  useEffect(() => {
    // debugger
    if (props.state.fornecedor != 0 && !controlUpdate) {
      loadData();
    } else {
      setControlUpdate(false)
    }
  }, [props.state.fornecedor]);

  useEffect(() => {
    const btnHistorico = {
      name: 'historico_agendamento',
      label: 'Histórico de agendamento',
      options: {
        display: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          let goTo = () => {
            saveFilter()
            const path = `/historico-de-agendamento/detalhes/${value.purchaseOrderId}/${value.productId}/${value.deliveryDate}/${value.branchId}`
            setTimeout(() => {
              router.push(path)
            }, 200);
          }
          return (
            <Button color="primary" align={"center"} onClick={() => { goTo() }
            }>
              <FontAwesomeIcon icon={faEye} size="2x" />
            </Button >
          )
        }
      },
    }
    columnsTodosPedidos.splice(13, 1, btnHistorico);
  }, [props.state.columnsTodosPedidos]);

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <SearchField
            searchField={searchFieldExternalTodosPedidos}
            handleChangeSearchFieldPedido={handleChangeSearchFieldExternalPedidoTodosPedidos}
            handleClickSearchField={handleClickSearchFieldTodosPedidos}
          />
        </Grid>
        {dataTodosPedidos.length > 0 &&
          <>
            <Grid item xs={3}>
              <TableColView
                groups={gruposColunasTodosPedidos}
                colunas={columnsTodosPedidos}
                onColumnUpdate={onColumnUpdateTodosPedidos}
              />
            </Grid>
            <Grid item xs={3}>
              <CSVLink data={exportData} filename={"TodosPedidos.csv"} separator={";"}>
                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={
                    <i className="material-icons">
                      file_download
                    </i>
                  }
                >
                  DOWNLOAD PLANILHA
                </Button>
              </CSVLink>
            </Grid>
          </>
        }
      </Grid>
      <br /><br />
      <OpcoesBuscaPopoverAllFilter
        searchField={searchFieldTodosPedidos}
        dtInitial={dtInitialTodosPedidos}
        dtEnd={dtEndTodosPedidos}
        escolhaData={escolhaDataTodosPedidos}
        escolhaFilial={escolhaFilialTodosPedidos}
        escolhaCondicao={escolhaCondicaoTodosPedidos}
        isColunasMultiple={true}

        colunas={colunasTodosPedidos}
        colunasFilterTags={colunasFilterTagsTodosPedidos}
        opcoesFilial={opcoesFilial}
        opcoesCondicao={opcoesCondicao}
        opcoesFiltroPedidos={opcoesFiltroPedidos}

        handlerCleanFilters={handlerCleanFiltersTodosPedidos}
        handlerAplicarFilters={handlerAplicarFiltersTodosPedidos}
        handlerChangeEscolhaFilial={handlerChangeEscolhaFilialTodosPedidos}
        handlerChangeEscolhaCondicao={handlerChangeEscolhaCondicaoTodosPedidos}
        handlerClearFilterTag={handlerClearFilterTagTodosPedidos}
        handleChangeSearchFieldPedido={handleChangeSearchFieldPedidoTodosPedidos}
        handlerClickCheckbox={handlerClickCheckboxTodosPedidos}
        handlerChangeDateInitial={handlerChangeDateInitialTodosPedidos}
        handlerChangeDateEnd={handlerChangeDateEndTodosPedidos}
        handlerChangeRadioEscolhaData={handlerChangeRadioEscolhaDataTodosPedidos}
      />
      <br />
      <FiltroStatusPedido
        opcoesFiltroPedidos={opcoesFiltroPedidos}
        label={"Filtro de pedidos"}
        btlabel={"CONFIRMAR"}
        handlerFiltroPedidos={handlerFiltroPedidos}
        opcoesFiltroPedidosValue={getFilters().opcoesFiltroPedidosValue}
      />
      <br /><br />
      <Tabela
        isLoading={isLoading}
        dataTodosPedidos={dataTodosPedidos}
        dataTodosPedidosIndexSelected={dataTodosPedidosIndexSelected}
        columnsTodosPedidos={columnsTodosPedidos}
        rowsPerPage={pageRowsTodosPedidos}
        page={pageInitialTodosPedidos}
        count={qtdTodosPedidos}
        rowsPerPageOptions={rowsPerPageOptionsTodosPedidos}
        handlerDataTodosPedidosSelected={handlerDataTodosPedidosSelected}
        handlerChangePageTodosPedidos={handlerChangePageTodosPedidos}
        handlerChangeRowsPerPage={handlerChangeRowsPerPageTodosPedidos}
      />
      <br />
      <Grid container align="center" >
        <Grid item xs={12} md={6}>
          <Button
            variant="outlined"
            color="primary"
            className={classes.itemButtonBar}
            onClick={() => { setModalManual(true) }}
          >
            MANUAL DE ETIQUETAS
          </Button>
        </Grid>
        <Grid item xs={12} md={6}>
          <Tooltip title={tooltip}>
            <Button
              disabled={isDownloadButtonDisabled}
              variant="contained"
              color="primary"
              className={classes.itemButtonBar}
              onClick={handleClickDownloadEtiquetasButton}
            >
              DOWNLOAD ETIQUETA
            </Button>
          </Tooltip>
        </Grid>
        <Grid item xs={6}>
        </Grid>
      </Grid>
      <MultiSelectModal
        checkedId={escolhaModalItensNovaOpcaoTodosPedidos}
        isModalOpen={openModalItensNovaOpcaoTodosPedidos}
        headerModal={{ title: "ESCOLHA A NOVA OPÇÃO DE PAGAMENTO" }}
        btComponent={{ label: "APLICAR ALTERAÇÕES" }}
        buttonType={'radio'}
        itensModal={opcoesModalItensNovaOpcao}
        setIdOnChange={handlerModalItensNovaOpcaoChangeTodosPedidos}
        getIdOnClick={handlerModalItensNovaOpcaoAplicarAlteracoesTodosPedidos}
        handleDialogModal={handlerModalItensNovaOpcaoCloseTodosPedidos}
      />
      <ModalTodosPedidosNovaOpcao
        open={openModalNovaOpcaoTodosPedidos}
        handlerClose={handlerModalNovaOpcaoCloseTodosPedidos}
        handlerEntendido={handlerModalNovaOpcaoEntendidoTodosPedidos}
      />
      <ModalEtiquetaOpcoes>
        <DownloadOpcoes
          handleClick={handleClickModalDownloadEtiquetas}
          toggleModal={toggleModalEtiquetaOpcoes}
          produtos={produtosSelectedEtiquetas}
        />
      </ModalEtiquetaOpcoes>
      <ModalEtiquetaConcluido>
        <DownloadConcluido toggleModal={toggleModalEtiquetaConcluido} />
      </ModalEtiquetaConcluido>
      <ModalManualEtiqueta
        setModalManual={setModalManual}
        modalManual={modalManual}
      />
    </>
  );
};